# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class StructuredData extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'StructuredDataModule'
#
#   @selector: ".structured_data_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# StructuredData.register()
